class CustomValidators {
    static testPassword = (password) => {
        return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8}/.test(password);
    };
}

export default CustomValidators;
